export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIME_OUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const FORM_TIME_OUT_SEC = 2;
export const KEY = 'a51ebcb4-558e-43ae-a6fe-ae1e921c8668';
